module.exports = __webpack_public_path__ + "static/akzent-logistics-ef330213cfef15737c0c44f6febf58e3.png";